import {detector} from "atom";

const {Detector, testers} = detector;

export default container => {
    container.declare("detector", ({settings}) => {
        const featuresDetector = new Detector();
        // add featuresFlags detection
        featuresDetector.add(testers.featuresFlags.bind(null, settings.featuresFlags));
        return featuresDetector;
    });
};
